import styled from 'styled-components/macro';
import { defaultContainer } from '../../../styles/utils';

export const CommissionRateInfoDiv = styled.div`
  ${defaultContainer}
  padding-top: 7rem;
  padding-bottom: 1rem;
  @media screen and (min-width: 768px) {
    display: flex;
  }
`;

export const CommissionRateCardDiv = styled.div`
  ${props => props.theme.defaultDropShadow}
  border-left: 3px solid ${props => props.theme.blue};
  padding: 3rem 3.5rem;
  flex-grow: 1;
  & + & {
    margin-top: 1.5rem;
  }
  p {
    padding: 0.5rem 0;
  }
  h5 {
    margin-bottom: 0.7rem;
  }
  p + p {
    border-top: ${props => props.theme.defaultBorder};
  }
  @media screen and (min-width: 768px) {
  & + & {
    margin-top: 0;
    margin-left: 1.5rem;
  }

  }
`;
